import { post } from '../../../../../api/baseUrl';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../../../../../store';
import { debouncePromise } from '../../../../helpers';

export const useGetAmtItems = () => {
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  const postGetAmtItems = debouncePromise(
    async ({
      searchText,
      concept,
    }: {
      searchText: string;
      concept: 'ctpp' | 'tpp' | 'tpuu' | 'mpuu' | 'mp' | 'mpp';
    }) => {
      if (!selectedTenancy) return;
      setIsLoading(true);
      try {
        const { data } = await post(`getAmtItems`, {
          searchText: searchText,
          concept: concept ?? undefined,
        });

        return Array.isArray(data.data) ? data.data : [];
      } catch (error: any) {
        console.error('An error occurred during getAmtItems', error);
        setErrorMessage(
          error?.response?.data?.message || 'Unknown error in getAmtItems',
        );
      } finally {
        setIsLoading(false);
      }
    },
    700,
  );

  return {
    postGetAmtItems,
    errorMessage,
    isLoading,
  };
};
